import config from '../config';
import axios from 'axios';

export const benefitRedeemService = {
  checkEligibility,
  redeem,
};

async function checkEligibility(campaignId) {
  const response = await axios.post(
    `${config.API_URL}/benefit-redeem/check`,
    { campaignId },
  );
  return response.data;
}

async function redeem(campaignId, redemptionCode) {
  const response = await axios.post(
    `${config.API_URL}/benefit-redeem/redeem`,
    { campaignId, redemptionCode },
  );
  return response.data;
}
